module.exports = __webpack_public_path__ + "static/media/trim-ped-o.1dc17244.png";